module.exports = __webpack_public_path__ + "img/tire-desktop.cd868e6.webp";